module.exports = __webpack_public_path__ + "img/pickup-package.edbfa94b.svg";